import { render, staticRenderFns } from "./CGoogleAd.vue?vue&type=template&id=716e37bb&scoped=true&"
import script from "./CGoogleAd.vue?vue&type=script&lang=ts&"
export * from "./CGoogleAd.vue?vue&type=script&lang=ts&"
import style0 from "./CGoogleAd.vue?vue&type=style&index=0&id=716e37bb&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "716e37bb",
  null
  
)

export default component.exports